import { nameOf } from '../app/shared/common';
import { RelativeUrl } from '../app/shared/Url';

export interface PricelistRouteParams {
  id: string;
}

export interface ProductRouteParams {
  id: string;
}

export class ModuleRoutes {
  /**
   * Module-relative, in the form the router registers them. Both tabs are the same page on the same
   * path — which of them is showing is a query parameter, so the listing has one URL, not two.
   */
  public static readonly paths = {
    listing: '/',
    pricelistDetails: `/lists/:${nameOf<PricelistRouteParams>('id')}`,
    productDetails: `/products/:${nameOf<ProductRouteParams>('id')}`,
  };

  public constructor(private readonly basePath: string) {}

  public listing(query: Map<string, string> = new Map<string, string>()): RelativeUrl {
    const url = RelativeUrl.parse(this.basePath);
    url.setQuery(query);

    return url;
  }

  public pricelistDetails(id: string): RelativeUrl {
    return this.resolve(ModuleRoutes.paths.pricelistDetails, nameOf<PricelistRouteParams>('id'), id);
  }

  public productDetails(id: string): RelativeUrl {
    return this.resolve(ModuleRoutes.paths.productDetails, nameOf<ProductRouteParams>('id'), id);
  }

  public isListing(url: RelativeUrl): boolean {
    return !!url?.path.equalsIgnoreCase(this.listing().path);
  }

  private resolve(pattern: string, param: string, value: string): RelativeUrl {
    return RelativeUrl.parse(`${this.basePath}${pattern.replaceAll(`:${param}`, encodeURIComponent(value))}`);
  }
}
